module.exports = __webpack_public_path__ + "static/IMG_2356-f3a16daf140455891f81787f348542cb.jpg";